<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div v-show="$route.path == '/Master/Supplier'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet kt-portlet--mobile">
          <div class="kt-portlet__head kt-portlet__head--lg">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="fa fa-user-tie"></i>
              </span>
              <h3 class="kt-portlet__head-title">จัดการข้อมูล Supplier</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <!-- begin: Search Form -->
            <form class="kt-form" @submit="formSubmit" ref="searchForm">
              <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                  <div class="form-group">
                    <label>คำค้นหา:</label>
                    <input
                      v-model="sulKeyword"
                      type="text"
                      class="form-control"
                      placeholder="ค้นหาจาก รหัส(Supplier) ชื่อ(Supplier) เลขประจำตัวผู้เสียภาษี อีเมล เบอร์โทร ที่อยู่"
                    />
                  </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                  <div class="form-group">
                    <label>สถานะ:</label>
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control m-select2'"
                      :id="'sulInActiveStatus'"
                      :name="'sulInActiveStatus'"
                      :select2-options="sulInActiveStatusOptions"
                      v-model="sulInActiveStatus"
                      ref="sulInActiveStatusSelect2"
                    ></select2>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-xl-6">
                  <button type="submit" class="btn btn-primary">ค้นหา</button>
                  <button type="reset" class="btn btn-secondary" @click="formReset">ล้างค่าทั้งหมด</button>
                </div>
                <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportSuplier"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
                
               </div>
                  
            </form>
            <!-- end: Search Form -->

            <!--begin: Datatable -->
            <div class="row">
              <div class="col-lg-12 table-responsive">
                <table
                  class="table-sm table-striped- table-bordered table-hover table-checkable"
                  id="supplierTable"
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th class="all">รหัส(Supplier)</th>
                      <th class="all">ชื่อ(Supplier)</th>
                      <th class="all">เลขประจำตัวผู้เสียภาษี</th>
                      <th class="all">E-mail</th>
                      <th class="all">เบอร์โทร</th>
                      <th class="none">ที่อยู่</th>
                      <th class="none">Latitude</th>
                      <th class="none">Longitude</th>
                      <!-- <th class="none">รูป</th> -->
                      <th class="all">สถานะ</th>
                      <th class="all">การจัดการ</th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            <!--end: Datatable -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#supplierTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          axios
            .put("/Api/Vendors/" + this.data.vendorId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#supplierTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          axios
            .put("/Api/Vendors/" + this.data.vendorId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูล Supplier">
      <i class="la la-edit"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({
        path: `/Master/Supplier/Update/${this.data.vendorId}`
      });
    }
  }
});

export default {
  components: {
    select2
  },
  data: function() {
    return {
      sulKeyword: "",
      sulInActiveStatus: false,
      //config
      sulInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null }
        ]
      }
    };
  },
  methods: {
    formReset: function(e) {
      this.sulKeyword = "";
      this.sulInActiveStatus = false;
      $("#sulInActiveStatus")
        .val(this.sulInActiveStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#supplierTable").DataTable();
      table.search();
      table.draw();
    },
    exportSuplier: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportSuplier",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.sulKeyword,
          InActiveStatus: self.sulInActiveStatus
          },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            // link.download = "ข้อมูลSuplier" + filename;
            link.download = "ข้อมูลSuplier" //+ filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    reloadDataTable: function(resetPaging = false) {
      $("#supplierTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    }
  },
  async mounted() {
    let self = this;

    //default inActive
    self.sulInActiveStatus = false;
    $("#sulInActiveStatus")
        .val(self.sulInActiveStatus + "")
        .trigger("change");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#supplierTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Vendors/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.sulKeyword,
                InActiveStatus: self.sulInActiveStatus
              })
            );
          }
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_"
        },

        // Order settings
        order: [[1, "desc"]],
        columns: [
          { data: null, orderable: false, defaultContent: "" },
          { data: "no", className: "text-center" },
          { data: "name", width: "20%", className: "text-center" },
          { data: "taxNo", className: "text-center" },
          { data: "email", className: "text-center" },
          { data: "tel", className: "text-center" },
          { data: "address", className: "text-center" },
          { data: "latitude", className: "text-center" },
          { data: "longitude", className: "text-center" },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            }
          },
          {
            data: "vendorId",
            className: "text-center",
            width: "13%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            }
          }
        ]
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow(['MANAGE_MASTER', 'MANAGE_SUPPLIER']);
            if (data.inActiveStatus == false)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == true)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow(['MANAGE_MASTER', 'MANAGE_SUPPLIER']);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Supplier/SupplierList.vue